import { render, staticRenderFns } from "./MenuBgClose.vue?vue&type=template&id=08d27332&scoped=true"
import script from "./MenuBgClose.vue?vue&type=script&lang=js"
export * from "./MenuBgClose.vue?vue&type=script&lang=js"
import style0 from "./MenuBgClose.vue?vue&type=style&index=0&id=08d27332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d27332",
  null
  
)

export default component.exports